<app-overlay
  *ngIf="isLoading"
  [overlayIsLoading]="true"
  data-cy="app-overlay"
></app-overlay>
<router-outlet></router-outlet>
